export interface OnelinkOptions {
    promoInstanceInSession?: number;
    promoInstanceInMonth?: number;
}

export function getOnelinkUrlInner(
    campaignVariant: string,
    testNames: string[] = [],
    isLoggedIn: boolean,
    options?: OnelinkOptions,
) {
    const serializedTestName = testNames.join(','); // Proctor groups with allocation IDs

    const userStatusParts = [
        `sgndIn=${isLoggedIn ? 1 : 0}`,
    ];
    if (options?.promoInstanceInSession !== undefined) {
        userStatusParts.push(`prmClsdS=${options.promoInstanceInSession}`);
    }
    if (options?.promoInstanceInMonth !== undefined) {
        userStatusParts.push(`prmClsdM=${options.promoInstanceInMonth}`);
    }
    const userStatusInformation = userStatusParts.join(',');

    const campaignParts = [
        serializedTestName,
        'utmend', // Custom delimiter for index builders
        userStatusInformation,
    ];
    const utmMedium = 'indeed_web';
    const utmCampaign = campaignParts.filter(Boolean).join(',');
    const targetUrl = makeTargetUrl(campaignVariant, utmMedium, utmCampaign);

    const onelinkUrl = new URL('https://indeed.onelink.me/oo1Z');
    onelinkUrl.searchParams.append('af_xp', 'custom');
    onelinkUrl.searchParams.append('pid', 'indeed_web'); // Media source in AppsFlyer
    onelinkUrl.searchParams.append('c', campaignVariant); // Campaign in AppsFlyer
    onelinkUrl.searchParams.append('af_adset', serializedTestName); // Adset in AppsFlyer
    // onelinkUrl.searchParams.append('indeed_sub1', ''); // Referer for analysis, but not used for now
    // onelinkUrl.searchParams.append('indeed_sub2', ctk);
    onelinkUrl.searchParams.append('targetUrl', targetUrl); // For iOS and Android
    onelinkUrl.searchParams.append('af_sub1', userStatusInformation); // Log-in status and promo instances
    onelinkUrl.searchParams.append('utm_source', campaignVariant); // used in web_to_app_overall_reach
    onelinkUrl.searchParams.append('utm_medium', utmMedium); // used in web_to_app_overall_reach
    onelinkUrl.searchParams.append('utm_campaign', utmCampaign); // used as grp in web_to_app_overall_reach
    onelinkUrl.searchParams.append('from', `w2a-${campaignVariant}`); // to be used in usersession & web_to_app_overall_reach

    return onelinkUrl.toString();
}

function makeTargetUrl(
    campaignVariant: string,
    utmMedium: string,
    utmCampaign: string,
    shouldAddLogIn?: boolean,
    shouldAddAutoSave?: boolean,
) {
    if (
        typeof location !== 'undefined' &&
        (location.href.includes('indeed.com') ||
            location.href.includes('indeed.net') ||
            location.href.includes('localhost'))
    ) {
        const url = new URL(location.href);
        url.searchParams.set('utm_source', campaignVariant);
        url.searchParams.set('utm_medium', utmMedium);
        url.searchParams.set('utm_campaign', utmCampaign);
        if (shouldAddAutoSave) {
            url.searchParams.set('autosavejob', '1');
        }
        const targetUrl = url.toString();
        if (shouldAddLogIn) {
            const urlWithLogIn = new URL('https://secure.indeed.com/account/login');
            urlWithLogIn.searchParams.set('from', 'savejobpromo');
            urlWithLogIn.searchParams.set('continue', targetUrl);
            return urlWithLogIn.toString();
        }
        return targetUrl;
    }

    return 'https://www.indeed.com/m';
}
